import { render, staticRenderFns } from "./ModalDel.vue?vue&type=template&id=5d9e3422&scoped=true"
import script from "./ModalDel.vue?vue&type=script&lang=js"
export * from "./ModalDel.vue?vue&type=script&lang=js"
import style0 from "./ModalDel.vue?vue&type=style&index=0&id=5d9e3422&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9e3422",
  null
  
)

export default component.exports